import {noise} from './../noise';
export const Blob = {

  init: function() {},
  getPath: function(span, time, pointOffset = 100) {
    const _m = span * 0.05;
    const _m2 = span * 0.3;
    const _5 = span*0.5;
    const _10 = span;

    function n(origin, range, staggerInt) {
      return origin + noise.simplex2(time + (pointOffset * staggerInt), staggerInt * 100) * range;
    }

    const tx = n(_5, _m, 0);
    const ty = n(0, _m, 1);

    const rx = n(_10, _m, 2);
    const ry = n(_5, _m, 3);

    const bx = n(_5, _m, 4);
    const by = n(_10, _m, 5);

    const lx = n(0, _m, 6);
    const ly = n(_5, _m, 7);

    let pathData = `M ${tx}, ${ty}`;
    pathData += `C ${tx + _m2}, ${ty}, ${rx}, ${ry - _m2}, ${rx}, ${ry}`; // top-right
    pathData += `C ${rx}, ${ry + _m2}, ${bx + _m2}, ${by}, ${bx}, ${by}`; // right-bottom
    pathData += `C ${bx - _m2}, ${by}, ${lx}, ${ly + _m2}, ${lx}, ${ly}`; // bottom-left
    pathData += `C ${lx}, ${ly - _m2}, ${tx - _m2}, ${ty}, ${tx}, ${ty}`; // left-top
    return pathData;
  },
};
